import { SharedModule } from './../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService, SimpleNotificationsModule } from 'angular2-notifications';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { SearchComponent } from './search/search.component';
import { ContactComponent } from './contact/contact.component';
import { AboutComponent } from './about/about.component';
import { PaymentComponent } from './payment/payment.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsAndConditionComponent } from './terms-and-condition/terms-and-condition.component';


@NgModule({
  declarations: [HeaderComponent, 
    FooterComponent, NavbarComponent, 
    SearchComponent, ContactComponent,
     AboutComponent, PaymentComponent,
      PrivacyComponent, TermsAndConditionComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      { path: 'contact', component: ContactComponent},
      { path: 'about', component: AboutComponent},
      { path: 'terms', component: TermsAndConditionComponent},
      { path: 'payment', component: PaymentComponent},
      { path: 'search/:value/:type', component: SearchComponent},
      { path: 'privacy', component: PrivacyComponent},
    ]),
    NgbModule,
    SimpleNotificationsModule.forRoot({
      position:["middle","center"],
       timeOut: 3000,
       showProgressBar: true,
       pauseOnHover: true,
       clickToClose: true
     })
  ],
  exports: [
    HeaderComponent, FooterComponent, NavbarComponent
  ]
})
export class LayoutModule { }
